import * as React from "react";
import { connect } from "react-redux";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import * as d from "../../reducers/domainReducer";
import { Link } from "react-router-dom";

class ProxyMgmtForPharamcyProxies extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.ProxyMgmtForPharamcyProxies.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        let { myChartRegistrationUrl, technicalHelpDeskNumber, technicalHelpDeskHours ,currentPharmacyUser } = this.props;
        let displayName = currentPharmacyUser ? currentPharmacyUser.firstName : "";
        return (
            <div className="container-fluid body-content proxy-mgmt-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="page-heading">Grant or Access Family Accounts ({displayName})</h1>
                            </div>
                            <div className="col-12">
                                <label>
                                    {displayName} must manage their family access within their own MyBSWHealth account. They must be at least 14 years old to have an account and can create one <Link to={{ pathname: myChartRegistrationUrl }} target="_blank">here</Link>.<br /><br />
                                    For assistance, please call the MyBSWHealth Technical Help Desk {technicalHelpDeskHours} at{' '} <a href={"tel:" + technicalHelpDeskNumber} className="phone-link">{technicalHelpDeskNumber}</a>.
                                    </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>);
    }
}

const mapStateToProps = (state) => {
    return {
        myChartRegistrationUrl: state.session.serverData && state.session.serverData.myChartRegistrationUrl,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        technicalHelpDeskHours: state.session.serverData ? state.session.serverData.technicalHelpDeskHours:"",
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu)
    };
};

export default connect(mapStateToProps)(ProxyMgmtForPharamcyProxies);